export default {
    noBooking: "NoBookingService",
    externalBooking: "ExternalBookingService",
    hotelBooking: "HotelBookingService",
    animodBooking: "AnimodBookingService"
};
